import { combineReducers } from 'redux';
import councils, * as dataSelectors from './regions';
import ui, * as uiSelectors from './ui';

const DROUGHT_STATUSES = [
  'Fully drought declared',
  'Partially drought declared',
  'Not drought declared',
];

const rootReducer = combineReducers({
  data: councils,
  ui: ui,
});

export default rootReducer;

export const getCouncils = (state) => dataSelectors.getCouncilsData(state.data);

export const getRegions = (state) => dataSelectors.getRegionsData(state.data);

export const getEntities = (state) => dataSelectors.getEntitiesData(state.data);

export const getQldCouncilsGeo = (state) =>
  dataSelectors.getQldCouncilsGeo(state.data);

export const getIsFetchingCouncils = (state) =>
  uiSelectors.getIsFetchingCouncils(state.ui);

export const getIsMobile = (state) => uiSelectors.getIsMobile(state.ui);

export const getDroughtStatusByRegion = (state) => {
  const regions = dataSelectors.getRegionsData(state.data);
  // All drought statuses
  const droughtStatuses = DROUGHT_STATUSES.reduce((acc, curr) => {
    return { ...acc, [curr]: 0 };
  }, {});
  // All region classifications
  const regionsObj = regions.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.highLevelClassification]: droughtStatuses,
    };
  }, {});

  // All region classifications with #of regions by drought status
  const droughtStatusByRegion = regions.filter(d => d.droughtStatus !== "-").reduce((acc, curr) => {
    return {
      ...acc,
      [curr.highLevelClassification]: {
        ...acc[curr.highLevelClassification],
        [curr.droughtStatus]:
          acc[curr.highLevelClassification][curr.droughtStatus] + 1,
      },
    };
  }, regionsObj);

  const droughtStatusWithPercentage = Object.entries(droughtStatusByRegion).map(
    ([key, breakdown]) => {
      const numRegionsInClassification = Object.values(breakdown).reduce(
        (a, c) => a + c,
        0
      );
      return {
        name: key,
        breakdown: breakdown,
        totalRegions: numRegionsInClassification,
      };
    }
  );

  return droughtStatusWithPercentage;
};

export const getActiveCouncil = (state) => {
  const activeCouncilId = uiSelectors.getActiveCouncil(state.ui);
  return activeCouncilId
    ? dataSelectors
        .getRegionsData(state.data)
        .find((council) => council.id === activeCouncilId)
    : null;
};

export const getActiveEntity = (state) => {
  const activeEntityId = uiSelectors.getActiveEntity(state.ui);
  return activeEntityId
    ? dataSelectors
        .getEntitiesData(state.data)
        .find((entity) => entity.id === activeEntityId)
    : null;
};

export const getComparedCouncil = (state) => {
  const comparisonCouncilId = uiSelectors.getComparedCouncil(state.ui);
  return comparisonCouncilId
    ? dataSelectors
        .getRegionsData(state.data)
        .find((council) => council.id === comparisonCouncilId)
    : null;
};

export const getComparedEntity = (state) => {
  const comparisonEntityId = uiSelectors.getComparedEntity(state.ui);
  return comparisonEntityId
    ? dataSelectors
        .getEntitiesData(state.data)
        .find((entity) => entity.id === comparisonEntityId)
    : null;
};

export const getActivePage = (state) => uiSelectors.getActivePage(state.ui);



// WEBPACK FOOTER //
// ./src/reducers/index.js